import useTranslation from 'next-translate/useTranslation'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import DocumentTitle from 'tennders-transactions/views/common/DocumentTitle'
import AddOrderDocument from 'tennders-documents/views/AddOrderDocument'
import { FINANCE_MODULE_UPLOAD_CMR } from 'tennders-stracture/libs/permissions'
import useSession from 'tennders-auth/hooks/useSession'
import AddCostInvoiceButton from 'tennders-finance/cost-invoice/components/AddCostInvoiceButton'
import GHref from 'tennders-market/common/components/element/GHref'
import Attachment from 'tennders-market/common/components/element/Attachment'
import AddDocument from 'tennders-documents/components/AddDocument'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { dispatchGenerateOrderDoc } from 'tennders-common/stores/prompt/action'
import { dateToStr } from 'tennders-stracture/libs/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import DocumentList from './DocumentList'

const CarriersDocuments = (props) => {
  const { transaction } = props
  const { isMe, isBroker } = useSession()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isUploadable = (transaction?.truckVisible) || transaction?.isTruckOwner
  const truck = transaction?.matchedTruck
  const [docs, setDocs] = React.useState(truck?.documents || [])
  const hasCmr = docs.find(doc => doc.type === 8)
  const hasOrderDoc = docs.find(doc => doc.type === 1)

  const addDoc = (file) => setDocs(prev => [...prev, file])

  useEffect(() => {
    setDocs(truck?.documents || [])
  }, [truck?.documents])

  const handleOrderDoc = () => {
    dispatch(dispatchGenerateOrderDoc({ transaction }))
  }

  if (transaction?.isCancelled) {
    return (
      <div className={isBroker() ? ' w-50' : 'w-100'}>
        <div className="pl-10 lh-1-3">
          <DocumentTitle
            title={isMe(truck?.createdBy) ? t('transaction:yourDocuments') : t('transaction:carriersDocs')}
            type="carrier"
            isBroker={isBroker}
            transaction={transaction}
          />
          <DocumentList
            documents={docs}
            setDocuments={setDocs}
            poc={truck?.company?.pointOfContact}
            transaction={transaction}
          />
        </div>
      </div>
    )
  }

  return (
    <div className=" w-50">
      <div className="pl-10 lh-1-3">
        <DocumentTitle
          title={isMe(truck?.createdBy) ? t('transaction:yourDocuments') : t('transaction:carriersDocs')}
          type="carrier"
          isBroker={isBroker}
          transaction={transaction}
        />
        {truck && transaction?.truckVisible && (
          <>
            {!hasOrderDoc && isUploadable && isBroker() && transaction?.matchedLoad && transaction.isApproved && (
              <div className="border-b pb-12 mb-12">
                <GHref onClick={handleOrderDoc}>
                  <FontAwesomeIcon icon={faPlus} className="mr-4" />
                  <span className="text-underline">{`${t('document:generateConfirmationDoc')}`}</span>
                </GHref>
              </div>
            )}
            {isUploadable
              && transaction?.isApproved
              && !transaction?.disabledActions?.includes('CREATE_COST_INVOICE')
              && hasOrderDoc
              && <AddCostInvoiceButton transaction={transaction} />}
            {isBroker() && transaction.bookedBy && (
              hasCmr
                ? (
                  <div className="border-b">
                    <Attachment
                      url={transaction.matchedTruck.cmrDocument?.fullUri}
                      title={
                        (transaction.matchedTruck.cmrDocument?.createdAtStr && transaction.matchedTruck.cmrDocument?.createdByStr)
                          ? (t('costInvoice:salesInvoiceUploadedBy', {
                            createdAt: dateToStr(new Date(transaction.matchedTruck.cmrDocument?.createdAtStr)),
                            createdBy: transaction.matchedTruck.cmrDocument?.createdByStr
                          }))
                          : ''
                      }
                    />
                  </div>
                )
                : (
                  (isUploadable && transaction.isApproved && hasOrderDoc && !transaction?.disabledActions?.includes('UPLOAD_CMR') && (
                    <RequiresPermission requiredPermissions={[FINANCE_MODULE_UPLOAD_CMR]}>
                      <AddOrderDocument
                        handleUpload={(_, file) => addDoc(file)}
                        title={t('document:uploadCmr')}
                        type="cmr"
                        id={transaction.id}
                      />
                    </RequiresPermission>
                  ))
                )
            )}
            <DocumentList
              documents={docs}
              setDocuments={setDocs}
              poc={truck?.company?.pointOfContact}
              transaction={transaction}
            />
            {isUploadable && <AddDocument addDoc={addDoc} id={transaction?.id} type="carrier" />}
          </>
        )}
      </div>
    </div>
  )
}

export default CarriersDocuments
